import React from 'react';
import { usePopupEvents, FlexBox, Typography, PopupConfig } from '@agilepoint/wat-react-ux';

export type _PopupConfig = Omit<PopupConfig, 'onRenderTitle'> & {
    headerTitle: string;
    width?: string;
    height?: string;
};

const cssStyles = [
    'padding: 0px;',
    '.ap-popup-header-wrapper {display: flex;background-color: #F1F2F4;height: 32px}',
    '.ap-popup-close-icon {position: absolute; top: 0; right: 0; }',
    '.ap-popup-content {padding: 22px 28px 40px 30px;}',
    '.ap-popup-footer {padding: 15px 30px 15px 0px;border-top: 1px solid #e5e8ee;box-sizing: border-box;}'
];

export const useCustomPopupEvents = () => {
    const { showPopup, ...rest } = usePopupEvents();

    const renderTitle = React.useCallback((headerTitle: string) => (
        <FlexBox justifyContent="center" alignItems="center" width="100%">
            <Typography.H6 title={headerTitle}>{headerTitle.toLocaleUpperCase()}</Typography.H6>
        </FlexBox >
    ), []);

    const showCustomPopup = React.useCallback((popupConfig: _PopupConfig) => {
        const { width, height, cssStyles: styles, headerTitle, ...restConfig } = popupConfig;
        const widthAndHeight = [];

        if (width && height) {
            widthAndHeight.push(`width: ${width};`, `height: ${height}`);
        } else if (width) {
            widthAndHeight.push(`width: ${width}`);
        } else if (height) {
            widthAndHeight.push(`height: ${height}`);
        }

        return showPopup({
            onRenderTitle: () => renderTitle(headerTitle),
            cssStyles: styles?.concat(...widthAndHeight) ?? cssStyles.concat(...widthAndHeight),
            ...restConfig
        });
    }, [renderTitle, showPopup]);

    return { showCustomPopup, ...rest };
};
